<div @accordionAnimation [ngClass]="{
    openSideMenuContainer: status === 'open',
    closeSideMenuContainer: status === 'close',
    invisibleMenu: status === '',
    'expanded': isExpanded
  }">
  <div class="modal-header">
    <h6 class="modal-title fs-5">
      {{ title }}
    </h6>
    <div class="d-flex align-items-center gap-2">

      <button *ngIf="masterType && showDocumentUpload" class="btn btn-sm btn-outline-secondary" (click)="openUploadModal()">
        <i class="fa fa-upload me-1"></i> Add Files
        <span *ngIf="totalFilesCount > 0" class="badge bg-success ms-2">
          {{ totalFilesCount }}
        </span>
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary btn-expand-toggle" (click)="toggleExpand()"
        [title]="isExpanded ? 'Collapse' : 'Expand'" [attr.aria-label]="isExpanded ? 'Collapse panel' : 'Expand panel'">
        <i class="fa-solid fa-up-right-and-down-left-from-center" [ngClass]="{'rotated': isExpanded}"></i>
      </button>
      <button type="button" class="btn-close btn-close-white" (click)="close()"></button>
    </div>
  </div>

  <!-- Slot for custom content -->
  <div class="p-1">
    <ng-content></ng-content>
  </div>
</div>
<ng-template #uploadModal let-modal>
  <!-- Header -->
  <div class="modal-header border-bottom shadow-sm">
    <h5 class="modal-title d-flex align-items-center">
      <i class="fa-solid fa-file-medical me-2"></i>
      <span>Add Documents</span>
    </h5>
    <button type="button" class="btn-close" (click)="handleModalClose()"></button>
  </div>

  <div class="modal-body">
    <!-- Upload Zone -->
    <div class="upload-action-grid mb-3">

      <!-- Browse Files -->
      <div class="upload-action-card browse" (click)="fileInput.click()">
        <input #fileInput type="file" hidden multiple (change)="onFilesSelected($event)" />

        <div class="action-icon">
          <i class="fa-solid fa-folder-open"></i>
        </div>

        <div class="action-title">Browse Files</div>
        <div class="action-subtitle">PDF, XLSX, JPG</div>
      </div>

      <!-- Camera -->
      <div class="upload-action-card camera" (click)="cameraInput.click()">

        <input #cameraInput type="file" hidden accept="image/*" capture="environment"
          (change)="onFilesSelected($event)" />

        <div class="action-icon">
          <i class="fa-solid fa-camera"></i>
        </div>

        <div class="action-title">Take Photo</div>
        <div class="action-subtitle">Open Camera</div>
      </div>

    </div>
    <!-- Selection Header: Shows combined count -->
    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
      <span class="text-uppercase fw-bold text-muted" style="font-size: 10px; letter-spacing: 1px;">
        Files in Queue ({{ (selectedFiles?.length || 0) + (showExistingInUploadModal ? (existingUploadedUrls?.length || 0) : 0) }})
      </span>
      <span *ngIf="showExistingInUploadModal && existingUploadedUrls?.length" class="badge bg-light text-dark border" style="font-size: 9px;">
        {{ existingUploadedUrls.length }} Already Saved
      </span>
    </div>

    <!-- Bulk label: fill every queued file's name at once, then still edit
         any individual one below if it needs a different value. Only worth
         showing once there's more than one file to name. -->
    <div class="attachment-label-section" *ngIf="showBulkCheckboxColumn">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <span class="attachment-label-caption mb-0">Document Name (Selected Files)</span>
        <button type="button" class="btn btn-link btn-sm p-0 select-all-toggle" (click)="toggleSelectAllForBulk()">
          {{ allSelectedForBulk ? 'Clear All' : 'Select All' }}
        </button>
      </div>
      <div class="d-flex gap-2">
        <ng-select class="doc-name-select flex-grow-1" [items]="effectiveAttachmentLabelSuggestions" [addTag]="onAddDocumentName"
          [clearable]="true" [appendTo]="'body'" [(ngModel)]="bulkAttachmentLabel"
          [notFoundText]="docNameNotFoundText" [addTagText]="addDocNameTagText"
          (search)="onDocNameSearch('bulk', null, $event.term)" (change)="onDocNameSelected('bulk', null)"
          (blur)="commitTypedDocName('bulk', null)"
          placeholder="Name selected files as... (optional)">
        </ng-select>
        <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap" (click)="applyBulkAttachmentInfo()">
          Apply to Selected
        </button>
      </div>
    </div>

    <!-- Documents list: one row per file (thumbnail, name, optional document
         name field, status, preview/delete) instead of a horizontal card
         scroller - easier to scan once there are more than 2-3 files. -->
    <div class="documents-list"
      *ngIf="selectedFiles?.length || (showExistingInUploadModal && existingUploadedUrls?.length)">
      <div class="documents-list-header" [class.has-label-col]="enableAttachmentLabel"
        [class.has-checkbox-col]="showBulkCheckboxColumn">
        <span *ngIf="showBulkCheckboxColumn" class="doc-col-check"></span>
        <span>File</span>
        <span *ngIf="enableAttachmentLabel">Document Name</span>
        <span>Status</span>
        <span class="text-end">Actions</span>
      </div>

      <!-- 1. EXISTING FILES (Stored on server) - omitted entirely when
           showExistingInUploadModal is off (e.g. company-detail's Documents
           tab, where this modal is an add-only flow). -->
      <div class="document-row" [class.has-label-col]="enableAttachmentLabel"
        [class.has-checkbox-col]="showBulkCheckboxColumn"
        *ngFor="let url of (showExistingInUploadModal ? existingUploadedUrls : []); let i = index">
        <div *ngIf="showBulkCheckboxColumn" class="doc-col-check">
          <input type="checkbox" [(ngModel)]="existingChecked[i]" [ngModelOptions]="{standalone: true}"
            title="Include in Apply to Selected" />
        </div>
        <div class="doc-col-file">
          <div class="doc-thumb">
            <img *ngIf="getFileTypeFromUrl(url) === 'image'" [src]="url" />
            <i *ngIf="getFileTypeFromUrl(url) !== 'image'" class="fa-solid" [ngClass]="{
              'fa-file-pdf pdf-theme': getFileTypeFromUrl(url) === 'pdf',
              'fa-file-excel excel-theme': getFileTypeFromUrl(url) === 'excel',
              'fa-file other-theme': getFileTypeFromUrl(url) === 'other'
            }"></i>
          </div>
          <span class="file-name-truncate text-muted" [title]="existingAttachments[i]?.name">{{ existingAttachments[i]?.name || ('Saved File ' + (i + 1)) }}</span>
        </div>
        <div *ngIf="enableAttachmentLabel" class="doc-col-label">
          <ng-select *ngIf="editingExistingIndex === i" class="doc-name-select"
            [items]="effectiveAttachmentLabelSuggestions" [addTag]="onAddDocumentName" [clearable]="true" [appendTo]="'body'"
            [(ngModel)]="existingLabels[i]" placeholder="Optional" [notFoundText]="docNameNotFoundText"
            [addTagText]="addDocNameTagText"
            (search)="onDocNameSearch('existing', i, $event.term)" (change)="onDocNameSelected('existing', i)"
            (blur)="commitTypedDocName('existing', i)">
          </ng-select>
          <span *ngIf="editingExistingIndex !== i" class="text-muted small">{{ existingLabels[i] || '—' }}</span>
        </div>
        <div class="doc-col-status"><span class="badge bg-success">Stored</span></div>
        <div class="doc-col-actions">
          <button class="doc-icon-btn" (click)="viewExistingFile(url)" title="Preview">
            <i class="fa fa-eye"></i>
          </button>
          <button *ngIf="enableAttachmentLabel && editingExistingIndex !== i" class="doc-icon-btn"
            (click)="toggleEditExisting(i)" title="Edit document name">
            <i class="fa-solid fa-pen"></i>
          </button>
          <button *ngIf="enableAttachmentLabel && editingExistingIndex === i" class="doc-icon-btn"
            (click)="cancelEditExisting(i)" title="Cancel">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <button *ngIf="allowRemoveExisting" class="doc-icon-btn text-danger" (click)="removeExistingFile(i)" title="Delete">
            <i class="fa-solid fa-trash-can"></i>
          </button>
        </div>
      </div>

      <!-- 2. NEW FILES (Pending Upload) -->
      <div class="document-row" [class.has-label-col]="enableAttachmentLabel"
        [class.has-checkbox-col]="showBulkCheckboxColumn"
        *ngFor="let f of selectedFiles; let i = index">
        <div *ngIf="showBulkCheckboxColumn" class="doc-col-check">
          <input type="checkbox" [(ngModel)]="selectedFileChecked[i]" [ngModelOptions]="{standalone: true}"
            title="Include in Apply to Selected" />
        </div>
        <div class="doc-col-file">
          <div class="doc-thumb">
            <img *ngIf="getFileTypeFromUrl(f.name) === 'image'" [src]="selectedFilePreviews[i]" />
            <i *ngIf="getFileTypeFromUrl(f.name) !== 'image'" class="fa-solid" [ngClass]="{
              'fa-file-pdf pdf-theme': getFileTypeFromUrl(f.name) === 'pdf',
              'fa-file-excel excel-theme': getFileTypeFromUrl(f.name) === 'excel',
              'fa-file other-theme': getFileTypeFromUrl(f.name) === 'other'
            }"></i>
          </div>
          <span class="file-name-truncate" [title]="f.name">{{ f.name }}</span>
        </div>
        <div *ngIf="enableAttachmentLabel" class="doc-col-label">
          <ng-select class="doc-name-select" [items]="effectiveAttachmentLabelSuggestions" [addTag]="onAddDocumentName"
            [clearable]="true" [appendTo]="'body'" [(ngModel)]="selectedFileLabels[i]" placeholder="Optional"
            [notFoundText]="docNameNotFoundText" [addTagText]="addDocNameTagText"
            (search)="onDocNameSearch('new', i, $event.term)" (change)="onDocNameSelected('new', i)"
            (blur)="commitTypedDocName('new', i)">
          </ng-select>
        </div>
        <div class="doc-col-status"><span class="badge bg-primary">New</span></div>
        <div class="doc-col-actions">
          <button class="doc-icon-btn" (click)="viewFile(i)" title="Preview">
            <i class="fa fa-eye"></i>
          </button>
          <button class="doc-icon-btn text-danger" (click)="removeSelectedFile(i)" title="Delete">
            <i class="fa-solid fa-trash-can"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!selectedFiles?.length && !(showExistingInUploadModal && existingUploadedUrls?.length)"
      class="empty-state-compact">
      <p class="mb-0">No documents selected for upload</p>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="modal-footer border-top bg-light">
    <div class="d-flex w-100 gap-2">
      <!-- Upload/Update Button -->
      <button class="btn btn-primary w-50 fw-bold" (click)="uploadFiles()" [disabled]="imageUploadLoading">
        <span *ngIf="imageUploadLoading" class="spinner-border spinner-border-sm me-2"></span>
        <i class="fa-solid fa-cloud-arrow-up me-1" *ngIf="!imageUploadLoading"></i>
        {{ imageUploadLoading ? 'Processing...' : (selectedFiles.length > 0 ? 'Upload New' : 'Save Changes') }}
      </button>
      <button type="button" class="btn btn-secondary w-50 fw-bold" (click)="handleModalClose()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>